/** Slot key: day|gender|division */
export const makeSlotKey = (day, gender, division) =>
  `${day}|${gender}|${division}`;

export const parseSlotKey = (key) => {
  const [day, gender, division] = key.split("|");
  return { day, gender, division };
};

/** Human label shown in team registration, e.g. "Bronze Men's Tuesday" */
export const formatOfferingLabel = (division, gender, day) =>
  `${division} ${gender} ${day}`;

export const slotsToDivisionLabels = (slotKeys) =>
  [...slotKeys]
    .map((key) => {
      const { day, gender, division } = parseSlotKey(key);
      return formatOfferingLabel(division, gender, day);
    })
    .sort((a, b) => a.localeCompare(b));

export const slotsFromRegistration = (registration, league) => {
  const stored = registration?.mixins?.offering_slots;
  if (Array.isArray(stored) && stored.length > 0) {
    return new Set(stored);
  }

  const days = registration?.mixins?.days_of_week || league?.days_of_week || [];
  const genders = league?.genders || [];
  const divisions = league?.divisions || [];
  const legacyDivisions = registration?.divisions || [];
  const slots = new Set();

  legacyDivisions.forEach((label) => {
    for (const day of days) {
      for (const gender of genders) {
        for (const division of divisions) {
          if (label === formatOfferingLabel(division, gender, day)) {
            slots.add(makeSlotKey(day, gender, division));
          }
        }
      }
    }
  });

  return slots;
};
